<tvsub-step-container (action)="onAction($event)" [step]="step" [steps]="steps()" [subsidyType]="type()">
	<form *ngIf="form" [formGroup]="form">
		<p class="u-text--bold u-m-bottom--xxs">
			Heb je tijdens de drie voorafgaande kalenderjaren de-minimissteun ontvangen?
      <tvcore-tooltip text="Meer info">
        <p>Voor meer info, zie handleiding.</p>
      </tvcore-tooltip>
		</p>

		<div class="c-radio">
			<input [value]="TripleAnwer.YES" formControlName="receivedDeminimis" id="yes" type="radio" />
			<label for="yes">Ja.</label>
		</div>
		<div class="c-radio">
			<input [value]="TripleAnwer.NO" formControlName="receivedDeminimis" id="no" type="radio" />
			<label for="no">Nee, ik heb tijdens de drie voorafgaande kalenderjaren geen de-minimissteun gekregen.</label>
		</div>
		<div class="c-radio">
			<input [value]="TripleAnwer.NOT_APPLICABLE" formControlName="receivedDeminimis" id="not_applicable" type="radio" />
			<label for="not_applicable">Nee, de wetgeving op de-minimissteun is niet van toepassing op mijn onderneming.</label>
		</div>
		<p *ngIf="controlHasError('receivedDeminimis')" class="u-text--error u-m-top--xxs">
			<i class="icon-warning-circle u-text--xlg"></i> Duid aan of je de-minimissteun ontvangen hebt.
		</p>

    <ng-container *ngIf="form.get('receivedDeminimis').value === TripleAnwer.YES">
      <hr class="hr-full" />

      <p class="u-text--bold u-m-bottom--xxs">
				Vul de gegevens in van de de-minimissteun die tijdens de drie voorafgaande kalenderjaren aan je onderneming werd toegekend.
      </p>

      <p *ngIf="showErrors && form.hasError('total')" class="u-text--error u-m-top--xxs u-m-bottom--sm">
        <i class="icon-warning-circle u-text--xlg"></i> Je mag maximaal 200 000 euro aan de-minimissteun ontvangen hebben.
      </p>

      <div *ngFor="let fd of form.get('financeDeminimis').controls; let i = index" [formGroup]="fd" class="u-row">
        <tvcore-datepicker [showErrors]="showErrors" class="u-col-md-3" label="Datum toekenning" name="grantDate">
          <tvcore-form-control-error name="required">Datum toekenning is verplicht.</tvcore-form-control-error>
          <tvcore-form-control-error name="dateBefore">Datum mag niet meer dan 2 jaar geleden zijn.</tvcore-form-control-error>
          <tvcore-form-control-error name="dateAfter">Datum mag niet na het huidige jaar vallen.</tvcore-form-control-error>
        </tvcore-datepicker>
        <tvcore-input [showErrors]="showErrors" class="u-col-md-4" label="Subsidiërende overheid" name="financier">
          <tvcore-form-control-error name="required">Subsidiërende overheid is verplicht.</tvcore-form-control-error>
        </tvcore-input>
        <tvcore-input [showErrors]="showErrors" class="u-col-md-3" label="Bedrag" name="totalAmount" type="price">
          <tvcore-form-control-error name="required">Bedrag is verplicht.</tvcore-form-control-error>
        </tvcore-input>
        <div *ngIf="form.get('financeDeminimis').length > 1" class="u-col-md-2">
          <button (click)="removeFinanceDeminimi(i)" class="c-btn-round u-m-top--mini" title="Financier verwijderen" type="button">
            <span class="icon-trash"></span>
          </button>
        </div>
      </div>

      <div class="u-row">
        <div class="u-col-md-7">
          <div (click)="addFinanceDeminimi()" class="c-btn-special u-m-top--xs u-m-bottom--md">
            <button class="c-btn-round u-m-right--xxs" title="Toevoegen" type="button">
              <span class="icon-plus"></span>
            </button>

            <span class="u-text--medium u-text--xlight">Toevoegen</span>
          </div>
        </div>
      </div>
    </ng-container>
	</form>
</tvsub-step-container>
